import { Capabilities } from '@shared/enums/capabilities';

export enum BenchmarkReportTypes {
  Heatmap = 'Heatmap',
  ClassComparison = 'Class Comparison',
  StandardsOverTime = 'Standards Over Time',
  StandardsDetail = 'Standards Detail',
  SkillAverage = 'Skill Average',
}

export enum BenchmarkQueryParamsByType {
  Heatmap = 'heatmap',
  ClassComparison = 'class-comparison',
  StandardsOverTime = 'standards-over-time',
  StandardsDetail = 'standards-detail',
  SkillAverage = 'skill-average',
}

export class BenchmarkReportTypeModel {
  type: BenchmarkReportTypes = undefined;
  queryParam: BenchmarkQueryParamsByType = undefined;
  capability: Capabilities = undefined;
}
